import React from 'react'
import PanelHead from '../../../UI/Panel/PanelHead'
import PanelBody from '../../../UI/Panel/PanelBody'
import AddRoleForm from '../../../UI/Roles/Add'

const AddRole = () => {
  return (
    <div>
      <PanelHead title="Add Role" />
      <PanelBody content={<AddRoleForm />} />
    </div>
  )
}

export default React.memo(AddRole);